import { hierarchyInitialState } from "../hierarchyInitialState";
import { HierarchyContextProps } from "../interface";

/**
 * Resets hierarchy state while preserving the cached hierarchy node list.
 *
 * @param state - The current hierarchy context state.
 * @returns The cleared hierarchy context state.
 */
export const hcr_clearHierarchy = (state: HierarchyContextProps): HierarchyContextProps => {
  return {
    ...hierarchyInitialState,
    hierarchyNodes: state.hierarchyNodes,
  };
};
